const fileTypes = [
  '.step',
  '.stp',
  '.x_b',
  '.x_t',
  '.xmt_bin',
  '.xmt_txt',
  '.igs',
  '.iges',
  '.catpart',
  '.sldprt',
  '.prt',
]
export default fileTypes
